import { ITranscription } from '../interfaces/ITranscriptionManager'
import 'isomorphic-fetch';
import { IStoredTranscription, TranscriptionStorageType } from '../interfaces/IStoredTranscription'
import { TranscriptionData } from '../utils/TranscriptionData';
import { SpeakerNameManager } from '../manager/speakerNameManager/SpeakerNameManager';
import { TRANSCRIPT_STORAGE_VERSION } from '../factory/TranscriptionManagerFactory';
import { IStoredTranscriptionArray } from '../interfaces/IStoredTranscriptionArray';
import { DocumentStorage } from '../office-js/DocumentStorage';
import { isNullOrUndefined } from '../../utils/utils';
import { StorageMigrationStatus } from './StorageMigrationHandler';
import { TranscriptionDocumentStorageManager } from './TranscriptionDocumentStorageManager';

export class MultiTranscriptionDocumentStorageManager extends TranscriptionDocumentStorageManager {
  private transcriptionDataArr: TranscriptionData[];
  private thresholdLimit: number = Number.POSITIVE_INFINITY;
  private storageVersion: number;

  public constructor(documentStorage: DocumentStorage, storedTransriptionArr: IStoredTranscription[], documentStorageType: TranscriptionStorageType, thresholdLimit: number, version: number = TRANSCRIPT_STORAGE_VERSION) {
    if (isNullOrUndefined(documentStorage)) {
      throw new Error("Document Storage can't be null");
    }

    super(documentStorage);

    if (thresholdLimit !== undefined && thresholdLimit > 0) {
      this.thresholdLimit = thresholdLimit;
    }
    this.documentStorageTypeFromStoredTranscription = documentStorageType;
    this.storageVersion = version;
    const storedTranscriptionSize = this.thresholdLimit < storedTransriptionArr.length ? this.thresholdLimit : storedTransriptionArr.length;
    this.transcriptionDataArr = new Array<TranscriptionData>();
    for (let i = 0; i < storedTranscriptionSize; i++) {
      this.transcriptionDataArr[i] = new TranscriptionData(storedTransriptionArr[i]);
    }
  }

  public GetTranscription(storageIndex: number = 0): ITranscription {
    if (storageIndex >= this.transcriptionDataArr.length || storageIndex < 0) {
      return {
        transcriptSegments: [],
      };
    }
    return this.transcriptionDataArr[storageIndex].GetTranscription();
  }

  public async UpdateTranscriptionSegment(segmentIndex: number, segmentText: string, speakerName: string | null, updateAll: boolean, storageIndex: number = 0) {
    if (storageIndex < 0 || storageIndex >= this.transcriptionDataArr.length)
      throw new Error('Invalid storage index');

    let transcription: ITranscription = this.transcriptionDataArr[storageIndex].GetTranscription();

    if (isNullOrUndefined(transcription.transcriptSegments))
      throw new Error("this.transcription.transcriptSegments is null");

    if (segmentIndex < 0 || segmentIndex >= transcription.transcriptSegments.length)
      throw new Error('Invalid segment index');

    transcription.transcriptSegments[segmentIndex].text = segmentText;

    let speakerNameManager: SpeakerNameManager = this.transcriptionDataArr[storageIndex].GetSpeakerNameManager();
    if (speakerNameManager != null && speakerName != null)
      speakerNameManager.UpdateSpeakerName(segmentIndex, speakerName, updateAll);

    await this.WriteStoredTranscription(this.GetAllStoredTranscription());
  }

  public GetStoredTranscription(storageIndex: number = 0): IStoredTranscription {
    if (storageIndex >= this.transcriptionDataArr.length || storageIndex < 0) {
      return {
        storageType: this.documentStorage.SupportedDocumentStorageType!,
        descriptor: {}
      }
    }
    return this.transcriptionDataArr[storageIndex].GetStoredTranscription();
  }

  public async WriteTranscriptionToStorage(storedTranscription: IStoredTranscription) {
    const transciptionData: TranscriptionData = new TranscriptionData(storedTranscription);
    this.transcriptionDataArr.unshift(transciptionData);
    if (this.transcriptionDataArr.length > this.thresholdLimit) {
      this.transcriptionDataArr.pop();
    }
    const storedTranscriptionArray = this.GetAllStoredTranscription();
    await this.WriteStoredTranscription(storedTranscriptionArray);
  }

  public async DeleteTranscription(storageIndex: number = -1) {
    if (storageIndex >= this.transcriptionDataArr.length) {
      return;
    }
    if (storageIndex <= -1) {
      this.transcriptionDataArr.pop();
    } else {
      this.transcriptionDataArr.splice(storageIndex, 1);
    }
    if (this.transcriptionDataArr.length == 0) {
      await this.DeleteStoredTranscription();
    } else {
      const storedTranscriptionArray = this.GetAllStoredTranscription();
      await this.WriteStoredTranscription(storedTranscriptionArray);
    }
  }

  public IsMultiTranscriptStorageSupported(): boolean {
    return true;
  }

  public GetStorageVersion(): number {
    return this.storageVersion;
  }

  public async HandleStorageMigration(): Promise<StorageMigrationStatus> {
    for (let i = 0; i < this.transcriptionDataArr.length; i++) {
      this.transcriptionDataArr[i].updateStorageType(this.documentStorage.SupportedDocumentStorageType!);
    }
    return super.HandleStorageMigration();
  }

  private GetAllStoredTranscription(): IStoredTranscriptionArray {
    let storedTranscriptionArr = new Array<IStoredTranscription>();
    for (let i = 0; i < this.transcriptionDataArr.length; i++) {
      storedTranscriptionArr[i] = this.transcriptionDataArr[i].GetStoredTranscription();
    }
    return {
      version: TRANSCRIPT_STORAGE_VERSION,
      storageType: this.documentStorage.SupportedDocumentStorageType!,
      storedTranscriptions: storedTranscriptionArr
    };
  }
}